import SalesRoute from './SalesRoute';

export default {
  name: 'Sales',
  location: '/sales',
  component: SalesRoute,
};
